import { render, staticRenderFns } from "./BetgameEditBetmode.vue?vue&type=template&id=4c5dd034&scoped=true"
import script from "./BetgameEditBetmode.vue?vue&type=script&lang=js"
export * from "./BetgameEditBetmode.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditBetmode.vue?vue&type=style&index=0&id=4c5dd034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5dd034",
  null
  
)

export default component.exports